import { AdvancedAnalysis } from "../models/AdvancedAnalysis";


export class AdvancedAnalysisSearchResult {
    constructor(
        public advancedAnalysisId: string,
        public advancedAnalysis: AdvancedAnalysis,
        public path: Array<number>,
        public topLevelParent: AdvancedAnalysis | undefined,
        public parent?: AdvancedAnalysis
    ) { }
}

export class AdvancedAnalysisSearchService {

    public static findAdvancedAnalysisByIdRecursive(
        advancedAnalyses: AdvancedAnalysis[],
        targetId: string
    ): AdvancedAnalysisSearchResult | null {
        return this.search(advancedAnalyses, targetId);
    }

    private static search(advancedAnalyses: AdvancedAnalysis[],
        targetId: string,
        parent?: AdvancedAnalysis,
        topLevelParent?: AdvancedAnalysis,
        path: number[] = []
    ): AdvancedAnalysisSearchResult | null {
        for (let i = 0; i < advancedAnalyses.length; i++) {
            const advancedAnalysis = advancedAnalyses[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? advancedAnalysis;

            if (advancedAnalysis.id === targetId) {
                return new AdvancedAnalysisSearchResult(targetId, advancedAnalysis, currentPath, currentTopLevel, parent);
            }

            const nestedAdvancedAnalyses = advancedAnalysis.configuration?.advancedAnalyses;
            if (Array.isArray(nestedAdvancedAnalyses)) {
                const result = this.search(nestedAdvancedAnalyses, targetId, advancedAnalysis, currentTopLevel, currentPath);
                if (result) return result;
            }
        }

        return null;
    }

    public static setAdvancedAnalysisAtPath(
        topLevelParent: AdvancedAnalysis,
        path: number[],
        newRule: AdvancedAnalysis
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentAdvancedAnalyses = topLevelParent.configuration?.advancedAnalyses;
        if (!Array.isArray(currentAdvancedAnalyses)) return false;

        // Traverse to the parent of the target AdvancedAnalysis
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const advancedAnalysis = currentAdvancedAnalyses[index];
            if (!advancedAnalysis?.configuration?.advancedAnalyses) return false;

            currentAdvancedAnalyses = advancedAnalysis.configuration.advancedAnalyses;
        }

        const targetIndex = path[path.length - 1]

        // Replace the target advancedAnalysis
        if (currentAdvancedAnalyses && currentAdvancedAnalyses[targetIndex]) {
            currentAdvancedAnalyses.splice(targetIndex, 1, newRule)
            return true;
        }

        return false;
    }

}